import {
  Grid,
  IconButton,
  Box,
  Typography,
  Button,
  CardMedia,
  Tooltip,
  Dialog,
  TextField,
  DialogContent,
  DialogTitle,
  Divider,
  DialogActions,
  Modal,
  Checkbox
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Email, Sms, FileCopy, Share, Close } from "@mui/icons-material";
import "react-quill/dist/quill.snow.css"; // Import styles for Quill editor
import EmailShare from "./sharingMethods/email";
import { useCart } from "../../hooks/shareContext";
import CloseIcon from "@mui/icons-material/Close";
import SMSshare from "./sharingMethods/sms";
import facebook from "../../assets/images/share_shareanimation/facebook.png";
import whatsapp from "../../assets/images/share_shareanimation/whatsapp.png";
import twitter from "../../assets/images/share_shareanimation/twitter-X.png";
import linkedin from "../../assets/images/share_shareanimation/linkedin.png";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import "../../styles/userPanel.scss";
import { axiosInstance } from "../../utils/tokenSetCookie";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const BASE_SHORT_URL = import.meta.env.VITE_BASE_SHORT_URL;
const API_UPLOAD_URL = import.meta.env.VITE_UPLOAD_MYVIDEO__URL;
import { SearchResult, UserDetails } from "../../types/types";
import LoginRestriction from "../../utils/loginRestriction";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";


interface Email {
  subject: string;
  message: string;
  type: string;
}

interface EmailDataContent {
  email: Email[];
  sms: Email[];
}
const ShareAnimation: React.FC = () => {
  const {
    selectAnim,
    setSelectAnim,
    myVideosAnim,
    setMyVideosAnim,
    cartCount,
    setCartCount,
    incrementCartCount,
    decrementCartCount,
  } = useCart();
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState<SearchResult>({
    animationDetails: [],
    myVideoDetails: []
  });

  // console.log(filteredData.myVideoDetails)
  const [changeCount, setChangeCount] = useState(cartCount);
  const [selectedIcon, setSelectedIcon] = useState("inbox");
  const [subjectContent, setSubjectContent] = useState<EmailDataContent>({
    email: [],
    sms: [],
  });
  const [userDetails, setUserDetails] = useState<UserDetails | null>(null);

  // copy purpose
  const [openCopy, setOpenCopy] = useState(false);
  const [open, setOpen] = useState(true);
  const [_copiedUrl, setCopiedUrl] = useState<string | null>(null);
  const [isShortUrl, setShortUrl] = useState(String);
  const { t } = useTranslation();
  const [isRestrictionOpen, setIsRestrictionOpen] = useState(false);
  const [openVideoModal, setOpenVideoModal] = useState(false);
  // const [isShared, setIsShared] = useState({
  //   open: false,
  //   id: 0
  // });
  const [checkedIds, setCheckedIds] = useState<number[]>([]);
  console.log("Cart Count", cartCount)
  console.log("CheckIDs", checkedIds)


  const [videos, setVideos] = useState({
    doctor: [
    ]
    ,
    patient_testimonial: [

    ],
    external_link: [
    ]
  });

  const allVideos = [
    ...videos.doctor,
    ...videos.patient_testimonial,
    ...videos.external_link,
  ];

  //MyVideos Get API Load Once 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(
          `${API_BASE_URL}my-videos/list`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status >= 200 && response.status < 300) {
          setVideos(response.data.data);
          console.log("API Response:", response.data.data);
        } else {
          console.error("API Failed:", response.status);
        }
      } catch (error) {
        const err = error as AxiosError;
        toast.error(err?.message ?? "Something went wrong");
      }
    };

    fetchData();
  }, []);



  // Get Email subject and message from the JSON file
  useEffect(() => {
    const fetchBannerData = async () => {
      try {
        const response = await axiosInstance.get(
          API_BASE_URL + "share/get-email-user-templates"
        );
        if (response.status >= 200 && response.status <= 300) {
          setSubjectContent(response.data.data);
        } else {
          console.log("Error");
        }
      } catch (error) {
        const errCode = error as AxiosError<{ status: number }>;
        if (errCode.response && errCode.response.status === 401) {
          setIsRestrictionOpen(true);
        } else {
          toast.error("Something went wrong", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
        }
        throw error;
      }
    };
    fetchBannerData(); // Passing the payload as an argument
  }, []);


  // Get User Details
  useEffect(() => {
    // Function to fetch data
    const getUsernDetail = async () => {
      try {
        const response = await axiosInstance.get(
          API_BASE_URL + "users/getuserdetails"
        );

        if (response.status >= 200 && response.status <= 300) {
          setUserDetails(response.data.data);
          localStorage.setItem(
            "fullscreenStatus",
            response.data.data.animationFullScreenStatus.toString()
          );
          localStorage.setItem(
            "animationDuration",
            response.data.data.animationDuration
          );
        }
      } catch (err) {
        console.log(err);
      }
    };
    getUsernDetail();
  }, []);


  // Combined Both Cart Count and Initial Local Storage

  useEffect(() => {
    const storedMyVideosAnim = localStorage.getItem("myVideosAnim");
    const storedSelectAnim = localStorage.getItem("selectAnim");

    const parsedMyVideosAnim = storedMyVideosAnim ? JSON.parse(storedMyVideosAnim) : [];
    const parsedSelectAnim = storedSelectAnim ? JSON.parse(storedSelectAnim) : [];

    // Set myVideosAnim if different
    if (myVideosAnim.length !== parsedMyVideosAnim.length ||
      JSON.stringify(myVideosAnim) !== JSON.stringify(parsedMyVideosAnim)) {
      setMyVideosAnim(parsedMyVideosAnim);
    }

    // Set selectAnim if different
    if (selectAnim.length !== parsedSelectAnim.length ||
      JSON.stringify(selectAnim) !== JSON.stringify(parsedSelectAnim)) {
      setSelectAnim(parsedSelectAnim);
    }

    // Set checkedIds if different
    if (checkedIds.length !== parsedMyVideosAnim.length ||
      JSON.stringify(checkedIds) !== JSON.stringify(parsedMyVideosAnim)) {
      setCheckedIds(parsedMyVideosAnim);
    }

    // Set cart count if different
    const totalCount = parsedMyVideosAnim.length + parsedSelectAnim.length;
    if (cartCount !== totalCount) {
      setCartCount(totalCount);
    }

    console.log("Loaded from localStorage:", {
      myVideosAnim: parsedMyVideosAnim,
      selectAnim: parsedSelectAnim
    });

  }, []);



  // Getting location lists

  useEffect(() => {
    if (selectAnim.length > 0 || myVideosAnim.length > 0) {
      const getUserDetail = async () => {
        const payload = {
          animationId: selectAnim?.join(","),
          myVideos: myVideosAnim?.join(","),
        };
        if (payload.animationId == "" && payload.myVideos == "") {
          return true;
        }
        try {
          const response = await axiosInstance.post(
            API_BASE_URL + "animation/details",
            payload
          );
          console.log("System Data", response);
          if (response.status >= 200 && response.status <= 300) {
            console.log(response.data.data)
            setFilteredData(response.data.data);
          }
        } catch (error) {
          const errCode = error as AxiosError<{ status: number }>;
          if (errCode.response && errCode.response.status === 401) {
            setIsRestrictionOpen(true);
          }
          throw error;
        }
      };
      getUserDetail(); // Passing the payload as an argument
    } else {


      if (
        (filteredData.animationDetails || []).length > 0 ||
        (filteredData.myVideoDetails || []).length > 0
      ) {
        setFilteredData({ animationDetails: [], myVideoDetails: [] });
      }


      // setFilteredData({ ...filteredData, animationDetails: [], myVideoDetails: [] });
      if (selectAnim.length > 0) {
        setSelectAnim([]);
      }

      if (changeCount !== 0) {
        setChangeCount(0);
      }

      if (cartCount !== 0) {
        setCartCount(0);
      }
      setOpenCopy(false);

      // Commented the issue code.
      navigator.clipboard.writeText(isShortUrl).then(() => {
        setCopiedUrl(isShortUrl);
      });
    }
  }, [selectAnim, myVideosAnim]);



  // Sharing purpose Once choose the icon change the templatedata
  const handleIconClick = (icon: string) => {
    if (icon === "inbox" || icon === "sms" || icon === "copy") {
      setSelectedIcon(icon);
      setOpen(false);
    } else if (icon === "share") {
      setSelectedIcon(icon);
      const payload = {
        trackType: "share_social_generate_link",
        languageId: 50,
        websiteId: 1,
        animationId: selectAnim.join(","),
      };
      const generateShortURL = async (payload: any) => {
        try {
          const response = await axiosInstance.post(
            API_BASE_URL + "share/social-media",
            payload
          );
          if (response.status >= 200 && response.status <= 300) {
            const shortCode = response.data.data.links[0].shortUrl;
            // Split the URL by '/'
            const urlSegments = shortCode.split("/");
            // Get the last segment
            const getCode = urlSegments[urlSegments.length - 1];

            const shortUrl = `${BASE_SHORT_URL}/${getCode}`;
            setShortUrl(shortUrl);
            setTimeout(() => {
              setOpen(true);
            }, 2000);

            // Copy the short URL to the clipboard
          }
        } catch (error) {
          const errCode = error as AxiosError<{ status: number }>;
          if (errCode.response && errCode.response.status === 401) {
            setIsRestrictionOpen(true);
          } else {
            toast.error("Something went wrong", {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
            });
          }
          throw error;
        }
      };
      generateShortURL(payload);
    }
  };

  // Once user remove animation it's affected on the cart
  const handleRemoveAnim = (rid: number) => {
    const updatedSelectAnim = selectAnim.filter((item) => item !== rid);
    setSelectAnim(updatedSelectAnim);

    const newCount = Math.max(cartCount - 1, 0);
    setChangeCount(newCount);
    decrementCartCount(changeCount);
    if (updatedSelectAnim.length === 0 && myVideosAnim.length === 0) {
      handleClearCart();
    }

    localStorage.setItem("selectAnim", JSON.stringify(updatedSelectAnim));

    setTimeout(() => {
      toast.success("Video Removed Successfully")
    }, 2000);
    // Decrement the cart count
    // const updatedCount = cartCount - 1; // Calculate the new count
    // setCartCount(updatedCount); // Update the state for cart count
    // decrementCartCount(updatedCount); // Pass the updated number directly
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(isShortUrl);
    setOpen(false);

    toast.success(t("copied_short_link_successful"), {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    setSelectedIcon("");
  };

  const handleFaceBook = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(isShortUrl)}`;
    window.open(facebookUrl, "facebook-share-dialog", "width=800,height=600");
  };
  //whatsapp -- share

  const handleWhatsAppShare = () => {
    const content = `Hai, I want to share animation with you! \n\n ${isShortUrl} \n\n\nRegards,\nDr.${userDetails?.firstName}`;
    const message = encodeURIComponent(content);
    const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);

    const whatsappUrl = isMobile
      ? `https://wa.me/?text=${message}`
      : `https://web.whatsapp.com/send?text=${message}`;

    window.open(whatsappUrl, "_blank");
  };
  //twitter -- share

  const handleTwitter = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(isShortUrl)}`;
    window.open(twitterUrl, "twitter-share-dialog", "width=800,height=600");
  };

  //linked -- share
  const handleLinkedIn = () => {
    const linkedInUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(isShortUrl)}`;
    window.open(linkedInUrl, "linkedin-share-dialog", "width=800,height=600");
  };

  //Dialog function --ends
  const handleCopyShortUrl = (_actionMode: string) => {
    const payload = {
      trackType: "share_copy_generate_link",
      languageId: 50,
      websiteId: 1,
      animationId: selectAnim.join(","),
    };
    const generateShortURL = async (payload: any) => {
      try {
        const response = await axiosInstance.post(
          API_BASE_URL + "share/copy-shortUrl",
          payload
        );
        if (response.status >= 200 && response.status <= 300) {
          const shortCode = response.data.data.links[0].shortUrl;
          // Split the URL by '/'
          const urlSegments = shortCode.split("/");
          // Get the last segment
          const getCode = urlSegments[urlSegments.length - 1];
          const shortUrl = `${BASE_SHORT_URL}/${getCode}`;
          setShortUrl(shortUrl);
          setTimeout(() => {
            setOpenCopy(true); // Open the dialog
          }, 2000);
          // Copy the short URL to the clipboard
          setSelectedIcon("");
        }
      } catch (error) {
        const errCode = error as AxiosError<{ status: number }>;
        if (errCode.response && errCode.response.status === 401) {
          setIsRestrictionOpen(true);
        } else {
          toast.error("Something went wrong", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
        }
        throw error;
      }
    };
    generateShortURL(payload);
  };

  const handleClearCart = () => {
    setSelectAnim([]); // Clear all items from selectAnim
    setChangeCount(0); // Reset the cart count
    setMyVideosAnim([])
    setCheckedIds([])
    decrementCartCount(0); // Update any additional logic for count if needed
    setCartCount(0);
    setOpenCopy(false);
    navigator.clipboard.writeText(isShortUrl).then(() => {
      setCopiedUrl(isShortUrl);
    });
    setFilteredData({ ...filteredData, animationDetails: [], myVideoDetails: [] });
    toast.success(t("cart_cleared"), {
      position: "top-right",
      autoClose: 1000,
      progress: undefined,
    });
  };

  const handleCloseDialog = () => {
    setCopiedUrl(null);
    setOpenCopy(false);
    navigator.clipboard.writeText(isShortUrl).then(() => {
      setCopiedUrl(isShortUrl);
    });
  };


  /*  const handleClickVideosAnim = (id: number) => {
 
     console.log("Video Added id", id)
     setMyVideosAnim((prevIds: number[]) => [...prevIds, id]);
     setChangeCount(cartCount + 1);
     incrementCartCount(changeCount);
   }; */

  const handleRemoveVideosAnim = (rid: number) => {
    const stored = localStorage.getItem("myVideosAnim");
    const storedIds: number[] = stored ? JSON.parse(stored) : [];

    const updatedIds = storedIds.filter((x) => x !== rid);
    setCheckedIds(updatedIds);


    // setIsShared({ ...isShared, open: !open, id: 0 })
    console.log("Video removed id", rid)

    const updatedSelectVideoAnim = myVideosAnim.filter((item) => item !== rid);
    setMyVideosAnim(updatedSelectVideoAnim);
    setChangeCount(cartCount - 1);
    decrementCartCount(changeCount);

    // if (updatedSelectVideoAnim.length === 0) {
    //   handleClearCart();
    // }
    setMyVideosAnim(updatedSelectVideoAnim)
    setTimeout(() => {
      toast.success("Video Removed Successfully")
    }, 2000);

  };

  const handleCheckMyVideoAnim = (id: number) => {
    const stored = localStorage.getItem("myVideosAnim");
    const storedIds: number[] = stored ? JSON.parse(stored) : [];

    const isChecked = storedIds.includes(id);

    if (isChecked) {
      console.log("Video removed id", id);
      setTimeout(() => {
        toast.success("Video Removed Successfully")
      }, 2000);

      const updatedIds = storedIds.filter((x) => x !== id);

      setCheckedIds(updatedIds);
      setMyVideosAnim(updatedIds);
      setChangeCount((prev) => {
        return prev - 1;
      });
      decrementCartCount(changeCount);

    } else if (changeCount >= 8) {
      return toast.error("You can share upto 8 videos")
    }
    else {
      console.log("Video added id", id);
      setTimeout(() => {
        toast.success("Video Added Successfully")
      }, 2000);

      const updatedIds = [...storedIds, id];
      setCheckedIds(updatedIds);
      setMyVideosAnim(updatedIds);
      setChangeCount((prev) => {
        return prev + 1;
      });
      incrementCartCount(changeCount);
    }
  };


  return (
    <>
      <Modal
        open={openVideoModal}
        onClose={() => setOpenVideoModal((prev) => !prev)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            bgcolor: "whitesmoke",
            borderRadius: "5px",
            width: "800px",
            height: "530px",
            overflow: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: "20px",
              borderBottom: "1px solid rgba(160, 160, 160, 0.47)",
            }}
          >
            <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>
              My Videos
            </Typography>
            <Close
              sx={{ cursor: "pointer" }}
              onClick={() => setOpenVideoModal((prev) => !prev)}
            />
          </Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: 4,
              p: "20px",
              overflowY: "scroll",
            }}
          >
            {allVideos?.map((video: any) => (
              <Box
                key={video.id}
                sx={{
                  width: "150px",
                  height: "120px",
                  border: "1px solid #e5e5e5",
                  borderRadius: "8px",
                  boxShadow: "2px 2px 2px #e5e5e5",
                  "&:hover": {
                    backgroundColor: "#e5e5e5",
                  },
                  cursor: "pointer",
                  position: "relative",
                }}
                onClick={() => console.log(video.id)}
              >
                <Box
                  component="img"
                  loading="lazy"
                  src={`${video.type == 3 ? video?.thumbImage : API_UPLOAD_URL + video?.thumbImage}`}
                  sx={{
                    width: "100%",
                    height: "85px !important",
                    objectFit: "cover",
                    backgroundSize: "cover",
                  }}
                  alt="thumb"
                />
                <Typography
                  sx={{
                    m: "5px",
                    fontSize: "14px",
                    textTransform: "capitalize",
                  }}
                >
                  {video.videoTitle.length > 25
                    ? video.videoTitle.slice(0, 15) + "..."
                    : video.videoTitle}
                </Typography>

                <Box
                  sx={{
                    position: "absolute",
                    top: -10,
                    right: -15,
                    borderRadius: "8px",
                    display: "inline-flex",
                    bgcolor: "white",
                  }}
                >
                  {/* {isShared.id === video.id ? <Close onClick={() => handleRemoveVideosAnim(video.id)} sx={{ backgroundColor: "#ed4242", color: "white", borderRadius: "99px", fontSize: "22px" }} /> :
                    <Share onClick={() => handleClickVideosAnim(video.id)} sx={{ bgcolor: "#1976d2", color: "white", borderRadius: "99px", p: "4px", fontSize: "18px", }} />} */}
                  <Box>
                    <Checkbox
                      checked={checkedIds.includes(video.id)}
                      sx={{ width: "28px", height: "28px" }}
                      onChange={() => handleCheckMyVideoAnim(video.id)}
                    />
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
          {/* <Box sx={{ display: "flex", justifyContent: "end", p: "20px", borderTop: "1px solid rgba(160, 160, 160, 0.47)" }}>
            <Button variant="contained" sx={{ borderTop: "1px" }}
            >Submit</Button>
          </Box> */}
        </Box>
      </Modal>
      {/* <ToastContainer /> */}
      <Grid
        container
        sx={{ paddingTop: "25px", height: "calc(100% - 5%)", width: "97%" }}
      >
        <Grid item sm={12} md={7} sx={{ padding: "10px" }}>
          {/* <SearchDropdown SearchList={setSearchList} /> */}

          <Box
            sx={{
              paddingTop: "0px",
              float: "right",
              marginRight: "0px",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => setOpenVideoModal((prev) => !prev)}
              sx={{ textTransform: "capitalize", mr: 1 }}
            >
              {t("Add MyVideos")}
            </Button>
            <Button
              disabled={!selectAnim.length && !myVideosAnim.length}
              variant="outlined"
              onClick={handleClearCart}
              sx={{ textTransform: "capitalize" }}
            >
              {t("remove_all_animations")}
            </Button>
          </Box>

          <Box>
            <Grid container sx={{ pt: 3 }}>
              {filteredData.animationDetails?.map((item, index) => (
                <Grid
                  item
                  sm={6}
                  xs={6}
                  md={3}
                  key={item.animationId}
                  sx={{ p: 1 }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      paddingTop: 3,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "0px",
                      "&:hover .icon-buttons": {
                        opacity: 1,
                        backgroundColor: "#1976d2",
                        borderRadius: "15px",
                      },
                    }}
                  >
                    <CardMedia
                      component="img"
                      loading="lazy"
                      image={item.bannerUrl}
                      alt={item.animationTagName}
                      sx={{
                        position: "relative",
                        width: "100%",
                        aspectRatio: "1.3 / 1",
                        objectFit: "cover",
                        marginBottom: "0%",
                        cursor: "pointer",
                        borderRadius: "15px",
                        transition: "all 0.3s ease-in-out",
                      }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: { xs: 0, sm: 0, md: 0 },
                        left: { xs: 0, sm: 0, md: 0 },
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        backgroundColor: "#00000061",
                        width: "100%",
                        padding: "10px 15px",
                        gap: "8px",
                        borderBottomLeftRadius: "15px",
                        borderBottomRightRadius: "15px",
                      }}
                    >
                      <Box>
                        {/* Tag Text */}
                        <Tooltip
                          title={t(item.animationTagName)}
                          placement="top"
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              fontSize: {
                                xs: "14px",
                                sm: "14px",
                                md: "14px",
                              },
                              color: "#fff",
                              textShadow: "0 1px 2px rgba(0, 0, 0, 0.6)",
                              textAlign: "left",
                              whiteSpace: "normal",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 2, // Limit to 2 lines
                              WebkitBoxOrient: "vertical",
                              maxWidth: "100%",
                            }}
                          >
                            {t(item.animationTagName).length > 40
                              ? t(item.animationTagName).substring(0, 40) +
                              "..."
                              : t(item.animationTagName)}
                          </Typography>
                        </Tooltip>
                        {/* <Typography variant="h6" sx={{ fontSize: "12px" }}>
                          {t(item.animationTagName)}
                        </Typography> */}
                      </Box>
                    </Box>
                    {/* Hover icons */}
                    <Box
                      className="icon-buttons"
                      sx={{
                        position: "absolute",
                        top: "8%",
                        right: "0px", // Move to the right side of the screen
                        transform: "translateY(-50%)", // Keep it centered vertically
                        display: "flex",
                        flexDirection: "column", // Align icons vertically
                        justifyContent: "center",
                        alignItems: "flex-end", // Align to the right side
                        opacity: 0,
                        transition: "opacity 0.3s, transform 0.3s", // Add transition for opacity and transform
                        "&hover": {
                          opacity: 1,
                          transform: "translateX(calc(100vw - 100%))",
                        },
                      }}
                    >
                      <IconButton
                        key={index}
                        sx={{ color: "white", margin: "4px", padding: "2px" }}
                      >
                        <CloseIcon
                          onClick={() => handleRemoveAnim(item.animationId)}
                          sx={{ fontSize: "16px", fontWeight: "600" }}
                        />
                      </IconButton>
                    </Box>
                  </Box>

                  {/* Play Button and Tag */}
                </Grid>
              ))}
              {filteredData.myVideoDetails?.map((item, index) => (
                <Grid
                  item
                  sm={6}
                  xs={6}
                  md={3}
                  key={item.videoId}
                  sx={{ p: 1 }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      paddingTop: 3,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "0px",
                      "&:hover .icon-buttons": {
                        opacity: 1,
                        backgroundColor: "#1976d2",
                        borderRadius: "15px",
                      },
                    }}
                  >
                    <CardMedia
                      component="img"
                      loading="lazy"
                      image={item.thumbImageUrl.startsWith("h") ? item.thumbImageUrl : API_UPLOAD_URL + item.thumbImageUrl}
                      alt={item.videoName}
                      sx={{
                        position: "relative",
                        width: "100%",
                        aspectRatio: "1.3 / 1",
                        objectFit: "cover",
                        marginBottom: "0%",
                        cursor: "pointer",
                        borderRadius: "15px",
                        transition: "all 0.3s ease-in-out",
                      }}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        bottom: { xs: 0, sm: 0, md: 0 },
                        left: { xs: 0, sm: 0, md: 0 },
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        backgroundColor: "#00000061",
                        width: "100%",
                        padding: "10px 15px",
                        gap: "8px",
                        borderBottomLeftRadius: "15px",
                        borderBottomRightRadius: "15px",
                      }}
                    >
                      <Box>
                        {/* Tag Text */}
                        <Tooltip title={t(item.videoName)} placement="top">
                          <Typography
                            variant="caption"
                            sx={{
                              fontSize: {
                                xs: "14px",
                                sm: "14px",
                                md: "14px",
                              },
                              color: "#fff",
                              textShadow: "0 1px 2px rgba(0, 0, 0, 0.6)",
                              textAlign: "left",
                              whiteSpace: "normal",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 2, // Limit to 2 lines
                              WebkitBoxOrient: "vertical",
                              maxWidth: "100%",
                            }}
                          >
                            {t(item.videoName).length > 40
                              ? t(item.videoName).substring(0, 40) + "..."
                              : t(item.videoName)}
                          </Typography>
                        </Tooltip>
                        {/* <Typography variant="h6" sx={{ fontSize: "12px" }}>
                          {t(item.videoName)}
                        </Typography> */}
                      </Box>
                    </Box>
                    {/* Hover icons */}
                    <Box
                      className="icon-buttons"
                      sx={{
                        position: "absolute",
                        top: "8%",
                        right: "0px", // Move to the right side of the screen
                        transform: "translateY(-50%)", // Keep it centered vertically
                        display: "flex",
                        flexDirection: "column", // Align icons vertically
                        justifyContent: "center",
                        alignItems: "flex-end", // Align to the right side
                        opacity: 0,
                        transition: "opacity 0.3s, transform 0.3s", // Add transition for opacity and transform
                        "&hover": {
                          opacity: 1,
                          transform: "translateX(calc(100vw - 100%))",
                        },
                      }}
                    >
                      <IconButton
                        key={index}
                        sx={{ color: "white", margin: "4px", padding: "2px" }}
                      >
                        <CloseIcon
                          onClick={() => handleRemoveVideosAnim(item.videoId)}
                          sx={{ fontSize: "16px", fontWeight: "600" }}
                        />
                      </IconButton>
                    </Box>
                  </Box>

                  {/* Play Button and Tag */}
                </Grid>
              ))}
            </Grid>
          </Box>
          {!filteredData.animationDetails.length && !filteredData.myVideoDetails?.length && (
            <Box className="share_sec_content">
              <Button
                variant="contained"
                sx={{
                  fontSize: "20px",
                  textAlign: "center",
                  fontWeight: "600",
                  mt: 3,
                  textTransform: "none",
                }}
                // fullWidth
                onClick={() => navigate("/")}
              >
                {t("please_choose_animation_to_share")}
              </Button>
            </Box>
          )}
        </Grid>

        <Grid
          item
          sm={12}
          md={5}
          sx={{
            padding: "15px", borderLeft: "1px solid #ddd",
            pointerEvents: cartCount > 0 ? "auto" : "none",
            opacity: cartCount > 0 ? 1 : 0.4
          }}
        >
          <Typography variant="h5" sx={{ marginBottom: "10px" }}>
            {t("share_choose_animation")}
          </Typography>

          <Box
            className="share_sec"
            sx={{
              height: "90%",
            }}
          >
            <Box display="block" justifyContent="space-around" padding="10px">
              <Box>
                <Tooltip title={t("share_by_email")} placement="top">
                  <IconButton
                    onClick={() => handleIconClick("inbox")}
                    className={`share_icons ${selectedIcon === "inbox" ? "active" : ""}`}
                  >
                    <Email />
                  </IconButton>
                </Tooltip>
                <Tooltip title={t("share_by_sms")} placement="top">
                  <IconButton
                    onClick={() => handleIconClick("sms")}
                    className={`share_icons ${selectedIcon === "sms" ? "active" : ""}`}
                  >
                    <Sms />
                  </IconButton>
                </Tooltip>
                <Tooltip title={t("share_by_a_link")} placement="top">
                  <IconButton
                    onClick={() => handleCopyShortUrl("copy")}
                    className="share_icons"
                  >
                    <FileCopy />
                  </IconButton>
                </Tooltip>
                <Tooltip title={t("share_by_social_media")} placement="top">
                  <IconButton
                    onClick={() => handleIconClick("share")}
                    className={`share_icons ${selectedIcon === "share" ? "active" : ""}`}
                  >
                    <Share />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
            {/* Form for Inbox Icon */}
            {selectedIcon === "inbox" && (
              <EmailShare
                emailData={subjectContent.email}
                selectedIcon={setSelectedIcon}
              />
            )}
            {selectedIcon === "sms" && (
              <SMSshare
                smsData={subjectContent.sms}
                selectedIcon={setSelectedIcon}
              />
            )}

            {selectedIcon === "share" && (
              <Dialog open={open} maxWidth="sm" fullWidth>
                <DialogTitle
                  sx={{ background: "#dde0e3", padding: "8px 16px" }}
                >
                  {t("share")}
                  <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: 5,
                      color: "black",
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                    sx={{ my: 3 }}
                  >
                    <IconButton color="primary" onClick={handleFaceBook}>
                      {/* <FacebookIcon /> */}
                      <img src={facebook} alt="facebook" loading="lazy"></img>
                    </IconButton>
                    <IconButton color="success" onClick={handleWhatsAppShare}>
                      {/* <WhatsAppIcon /> */}
                      <img src={whatsapp} alt="facebook"></img>
                    </IconButton>
                    <IconButton color="primary" onClick={handleTwitter}>
                      {/* <TwitterIcon /> */}
                      <img src={twitter} alt="facebook"></img>
                    </IconButton>
                    <IconButton
                      sx={{ color: "#0077B5" }}
                      onClick={handleLinkedIn}
                    >
                      {/* <LinkedInIcon /> */}
                      <img src={linkedin} alt="facebook"></img>
                    </IconButton>
                  </Box>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={10}>
                        <TextField
                          value={isShortUrl}
                          fullWidth
                          variant="outlined"
                          InputProps={{
                            readOnly: true,
                            sx: {
                              height: "40px",
                              padding: "0px 12px",
                            },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              height: "40px",
                            },
                          }}
                        />
                      </Grid>

                      <Grid item xs={2}>
                        <Button
                          variant="contained"
                          color="error"
                          onClick={handleCopy}
                          sx={{
                            textTransform: "none",
                            height: "40px",
                            width: "100%",
                          }}
                        >
                          {t("copy")}
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </DialogContent>
              </Dialog>
            )}
          </Box>
        </Grid>

        <Dialog open={openCopy} onClose={handleCloseDialog}>
          <DialogTitle sx={{ backgroundColor: "#1976d2", color: "#fff" }}>
            {t("the_shareable_url_has_been_copied")}{" "}
          </DialogTitle>
          <DialogContent sx={{ padding: "20px !important" }}>
            {t("are_you_sure_want_to_clear_the_cart")}
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button
              onClick={handleClearCart}
              color="primary"
              sx={{ backgroundColor: "#1976d2", color: "#fff" }}
            >
              {t("yes")}
            </Button>
            <Button
              onClick={handleCloseDialog}
              color="primary"
              sx={{
                backgroundColor: "transparent",
                border: "1px solid #1976d2",
                color: "#1976d2",
              }}
            >
              {t("no")}
            </Button>
          </DialogActions>
        </Dialog>
        <LoginRestriction open={isRestrictionOpen} />
      </Grid>
    </>
  );
};

export default ShareAnimation;
